export default "/_next/static/fonts/tt_norms_pro_thin_italic-af454b29fbcb47f42f318ec1793e3811.woff";